<template>
  <div class="container">
    <hooper class="tuto-hooper">
      <slide class="tuto-slide">
        <div class="tuto-title">
          <p>독도 지킴이가 되어 주세요.</p>
        </div>
        <img class="tuto-img1" src="../assets/img/tutorial1_3.png" />
        <div class="tuto-desc">
          <p>
            독도의 날로 지정된 10월 25일은 대한제국의 고종 황제가 칙령 제41호를
            반포하여 독도가 우리 영토임을 명확히 한 날입니다.
          </p>
        </div>
        <div class="tuto-desc">
          <p>
            대한제국 이전에도 독도는 우리 영토였지만 일본은 여전히 터무니없는
            주장을 펼치고 있습니다.
          </p>
        </div>
      </slide>
      <slide class="tuto-slide">
        <div id="tuto-title2" class="tuto-title">
          <p>반드시 기억해야하는<br />독도 이야기</p>
        </div>
        <img class="tuto-img pair" src="../assets/img/tutorial2_3.png" />
        <div class="tuto-desc">
          <p>독도에 관한 다양한 정보가 기사 형태로 흩어져 있습니다.</p>
        </div>
        <div class="tuto-desc">
          <p>
            많은 기사 중에서 대한민국 국민이라면 반드시 기억해야 할 메시지가
            핵심 기사에 숨겨져 있습니다.
          </p>
        </div>
      </slide>
      <slide class="tuto-slide">
        <div class="tuto-title">
          <p>기사 작성 방법</p>
        </div>
        <img class="tuto-img" src="../assets/img/tutorial3_2.png" />
        <div class="tuto-desc">
          <p>
            육하원칙에 따라 흩어져 있는 <br />
            단서들을 찾아 코드를 입력하세요.
          </p>
        </div>
        <div class="tuto-desc">
          <p>
            완성한 기사는 데스크의 확인을 받은 후 <br />
            기사를 발행할 수 있습니다.
          </p>
        </div>
      </slide>
      <slide class="tuto-slide">
        <div class="tuto-title">
          <p>점수 및 난이도</p>
        </div>
        <img class="tuto-img" src="../assets/img/tutorial5.png" />
        <div class="tuto-desc">
          <p>
            가볍게 풀 수 있는 100p 기사를 <br />
            먼저 작성하세요.
          </p>
        </div>
        <div class="tuto-desc">
          <p>
            점수가 높을수록 <br />
            주어지는 단서가 적습니다.
          </p>
        </div>
      </slide>
      <slide class="tuto-slide">
        <div class="tuto-title">
          <p>게임 목표</p>
        </div>
        <img class="tuto-img" src="../assets/img/tutorial4_2.png" />
        <div class="tuto-desc">
          <p>주어진 시간 동안 독도 지킴이를 목표로 독도 포인트를 쌓으세요!</p>
        </div>
        <router-link
          class="tuto-final-button"
          to="/game"
          @click.native.prevent="gamestart"
          >시작하기</router-link
        >
      </slide>
      <hooper-navigation slot="hooper-addons"></hooper-navigation>
    </hooper>
  </div>
</template>

<script>
/* eslint-disable */
import {
  Hooper,
  Slide,
  Pagination as HooperPagination,
  Navigation as HooperNavigation,
} from "hooper";
import "hooper/dist/hooper.css";
export default {
  components: {
    Hooper,
    Slide,
    HooperPagination,
    HooperNavigation,
  },
  mounted() {
    this.gamestart();
  },
  data() {
    return {
      showModal: false,
    };
  },
  methods: {
    gamestart: function () {
      this.$store.dispatch("loadTime");
      this.$store.dispatch("loadSectionState");
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/tutorial.vue